export default "__VITE_ASSET__ecg3mEx3__"